/* src/app/components/ai-library/ai-library/e-library-details/ai-library-upload/ai-library-upload.component.scss */
::ng-deep .angular-editor-textarea {
  background: #fff !important;
}
.library-upload-view .input {
  height: 2rem !important;
  font-size: 0.9rem !important;
}
.library-upload-view .questionnarie {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px !important;
  width: 98%;
  margin: 0.9rem auto;
  padding: 10px 5px;
  background: #fafafa !important;
}
.library-upload-view .questionnarie .input {
  width: 90% !important;
}
.library-upload-view .questionnarie .radio {
  font-size: 0.9rem;
}
.library-upload-view .question-option .input {
  width: 80% !important;
}
.library-upload-view .question-option .is-checkradio[type=radio] + label:first-of-type {
  margin-left: 10px;
}
.library-upload-view .question-option .is-checkradio[type=radio] + label,
.library-upload-view .question-option .is-checkradio[type=checkbox] + label {
  padding: 0.2rem 0.8rem !important;
}
.library-upload-view .flex-container .flex-item {
  width: 100%;
}
.library-upload-view .flex-container .flex-item .card .card-body {
  overflow-y: auto;
  min-height: 50vh;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img {
  width: 100% !important;
  height: 42px !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options {
  background: none !important;
  right: 0px !important;
  border-radius: 0% !important;
  text-align: left !important;
  left: 0px;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options .fa {
  color: #000 !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options .upload-file-form {
  height: calc(100vh - 150px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options .container {
  height: calc(100vh - 220px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.library-upload-view .flex-container .flex-item .card .card-body .responsiveRadioBtn {
  margin: 10px 0;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section {
  padding: 1rem 2rem 0rem 0rem;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .removeAssQuestion {
  float: right;
  top: -32px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: relative;
  right: -29px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .removeAssQuestion:hover {
  color: #d62e2e !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs ul {
  font-size: 15px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie {
  margin-bottom: 20px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs li.is-active a {
  border-bottom-color: var(--primaryColor) !important;
  color: var(--primaryColor) !important;
  font-weight: 700;
  font-size: 14px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-choice {
  padding: 1rem 2rem 1rem 2rem;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .questionOption {
  padding: 0rem 0rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option {
  padding: 1rem 9rem 3rem 2rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control {
  margin-bottom: 10px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .removeOptions {
  float: right;
  top: 5px;
  width: 30px;
  height: 30px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: absolute;
  right: -69px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .removeOptions:hover {
  color: #d62e2e !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label:before {
  border: 3px solid #f14668;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio],
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio] + label:first-of-type,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox] + label:first-of-type {
  float: right;
  position: absolute;
  margin-left: 10px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:before {
  animation-name: none;
  border: 0.1rem solid #dbdbdb;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::after,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:after,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::after,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:after {
  display: inline-block;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .survey_question .is-checkradio[type=checkbox] + label {
  font-size: 1rem !important;
  padding-left: 2rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .survey_question .is-checkradio[type=checkbox] + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .survey_question .is-checkradio[type=checkbox] + label:before {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarieAns {
  padding: 2rem 0rem;
  margin-top: -7%;
}
.library-upload-view .flex-container .flex-item .card .card-body .columns .file-label {
  text-align: left !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: bold;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label::before,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label:before {
  background: var(--primaryColor);
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-sucess + label::before,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:before {
  left: auto;
  right: -0.375rem;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label::before,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label:before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: 0.25rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label::after,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label::after,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label:after {
  left: auto;
  right: 0;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish {
  width: 100% !important;
  margin-left: 26px;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .responsiveRadioBtn {
  margin: 20px 0;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: bold;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label::before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: -0.375rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonSubmitBtn {
  position: absolute;
  top: 5px;
  right: 0px;
}
.library-upload-view .upload-file-form {
  height: calc(100vh - 260px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.library-upload-view .container-file {
  height: calc(100vh - 350px);
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
}
.library-upload-view .card .card-body .questionnaries {
  border-left: 1px solid #acacac;
}
.tabs {
  padding: 0.5rem 0rem;
}
@media screen and (max-width: 320px) and (max-width: 767px) {
  .library-upload-view .flex-container .flex-item .card .card-body {
    max-height: calc(100vh - 293px);
    overflow-x: hidden;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs ul {
    font-size: 15px !important;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs li.is-active a {
    border-bottom-color: var(--primaryColor) !important;
    color: var(--primaryColor) !important;
    font-weight: 700;
    font-size: 14px;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option {
    padding: 1rem 0rem 3rem 2rem;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .angular-editor-wrapper .angular-editor-textarea {
    padding: 0.5rem 1.8rem 1rem !important;
  }
  .library-upload-view .flex-container .flex-item .card .card-body {
    max-height: calc(100vh - 293px);
    overflow-x: hidden;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option {
    padding: 1rem 0rem 3rem 1rem !important;
  }
}
/*# sourceMappingURL=ai-library-upload.component.css.map */
